import React, { useState, useContext, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ENUMS from '../../../../enums';
import AddCafeContext from '../AddOrEditCafeContext';
import { formatter, validator } from '../../../../utils';
import { dataGenerator } from '../../../../utils';

const AddOrEditContact = props => {
  const [value, setContactValue] = useState('');
  const [type, setContactType] = useState(ENUMS.CONTACT_TYPES.values.MOBILE);
  const [valuePlaceholder, setContactValuePlaceholder] = useState('مانند: 09170123456');
  const [maxLengthValue, setMaxLengthValue] = useState(11);
  const cafeContext = useContext(AddCafeContext);

  const [valueInputInvalidMessage, setContactValueInputInvalidMessage] = useState('');
  const [valueInputValidateStatus, setContactValueInputValidateStatus] = useState('');

  const onChangeValue = event => {
    const value = event.target.value;
    setContactValue(value);

    setContactValueInputInvalidMessage('');
    setContactValueInputValidateStatus('');
  };

  const onChangeContactType = event => {
    const type = event.target.value;

    setContactValue('');
    setContactType(type);

    switch (type) {
      case ENUMS.CONTACT_TYPES.values.MOBILE:
        setContactValuePlaceholder('مانند: 09170123456');
        setMaxLengthValue(ENUMS.MAX_LENGTH.mobileNumber);
        break;
      case ENUMS.CONTACT_TYPES.values.PHONE:
        setContactValuePlaceholder('مانند: 07131321123');
        setMaxLengthValue(ENUMS.MAX_LENGTH.phoneNumber);
        break;
      case ENUMS.CONTACT_TYPES.values.INSTAGRAM:
        setContactValuePlaceholder('مانند: instagram_page_name');
        setMaxLengthValue(ENUMS.MAX_LENGTH.instagramAccount);
        break;
      case ENUMS.CONTACT_TYPES.values.WEBSITE:
        setContactValuePlaceholder('مانند: www.atigh.ir');
        setMaxLengthValue(ENUMS.MAX_LENGTH.website);
        break;
      case ENUMS.CONTACT_TYPES.values.EMAIL:
        setContactValuePlaceholder('مانند: info@atigh.ir');
        setMaxLengthValue(ENUMS.MAX_LENGTH.email);
        break;
    }
  };

  const validateModalForm = () => {
    let isValueValid = true;

    const formattedContactValue = formatter.toStandard(value);

    if (!formattedContactValue) {
      setContactValueInputInvalidMessage(
        locales('messages.fieldValueIsRequired', { fieldName: locales('fields.contact.value') })
      );
      setContactValueInputValidateStatus('is-invalid');
      isValueValid = false;
    } else {
      let isFormatValid = false;

      switch (type) {
        case ENUMS.CONTACT_TYPES.values.MOBILE:
          isFormatValid = validator.isMobileNumber(formattedContactValue);
          break;
        case ENUMS.CONTACT_TYPES.values.PHONE:
          isFormatValid = validator.isPhoneNumber(formattedContactValue);
          break;
        case ENUMS.CONTACT_TYPES.values.INSTAGRAM:
          isFormatValid = validator.isValidInstagramUserName(formattedContactValue);
          break;
        case ENUMS.CONTACT_TYPES.values.WEBSITE:
          isFormatValid = validator.isWebsiteUrl(formattedContactValue);
          break;
        case ENUMS.CONTACT_TYPES.values.EMAIL:
          isFormatValid = validator.isEmailAddress(formattedContactValue);
          break;
      }

      if (!isFormatValid) {
        setContactValueInputInvalidMessage(
          locales('messages.fieldValueHasNotCorrectFormat', { fieldName: locales('fields.contact.value') })
        );
        setContactValueInputValidateStatus('is-invalid');
        isValueValid = false;
      } else if (props.editMode) {
        let isDuplicate = props.isContactItemDuplicate({
          value: formattedContactValue,
          type,
          excludedContactValue: props.value
        });

        if (isDuplicate) {
          setContactValueInputInvalidMessage(
            locales('messages.fieldValueIsDuplicate', { fieldName: locales('fields.contact.value') })
          );
          setContactValueInputValidateStatus('is-invalid');
          isValueValid = false;
        }
      } else {
        const isDuplicate = props.isContactItemDuplicate({
          value: formattedContactValue,
          type
        });

        if (isDuplicate) {
          setContactValueInputInvalidMessage(
            locales('messages.fieldValueIsDuplicate', { fieldName: locales('fields.contact.value') })
          );
          setContactValueInputValidateStatus('is-invalid');
          isValueValid = false;
        }
      }
    }

    return !!isValueValid;
  };

  const saveContactItem = () => {
    const isFormValid = validateModalForm(props.editMode);

    if (!isFormValid) {
      return;
    }

    if (props.editMode === true) {
      cafeContext.editContactItem({
        itemKey: props.itemKey,
        type,
        value
      });
    } else {
      cafeContext.addContactItem({
        itemKey: dataGenerator.generateKey('contact_item'),
        type,
        value
      });
    }

    props.closeModal();
  };

  const cancel = () => {
    props.closeModal();
  };

  useEffect(() => {
    if (props.editMode === true) {
      setContactType(props.type);
      setContactValue(props.value);
      const type = props.type;
      switch (type) {
        case ENUMS.CONTACT_TYPES.values.MOBILE:
          setContactValuePlaceholder('مانند: 09170123456');
          setMaxLengthValue(ENUMS.MAX_LENGTH.mobileNumber);
          break;
        case ENUMS.CONTACT_TYPES.values.PHONE:
          setContactValuePlaceholder('مانند: 07131321123');
          setMaxLengthValue(ENUMS.MAX_LENGTH.phoneNumber);
          break;
        case ENUMS.CONTACT_TYPES.values.INSTAGRAM:
          setContactValuePlaceholder('مانند: instagram_page_name');
          setMaxLengthValue(ENUMS.MAX_LENGTH.instagramAccount);
          break;
        case ENUMS.CONTACT_TYPES.values.WEBSITE:
          setContactValuePlaceholder('مانند: www.atigh.ir');
          setMaxLengthValue(ENUMS.MAX_LENGTH.website);
          break;
        case ENUMS.CONTACT_TYPES.values.EMAIL:
          setContactValuePlaceholder('مانند: info@atigh.ir');
          setMaxLengthValue(ENUMS.MAX_LENGTH.email);
          break;
      }
    }
  }, [props]);

  console.log(props)
  return (
    <Modal isOpen={props.isOpen}>
      <ModalHeader>
        {props.editMode ? locales('titles.edit.contact.item') : locales('titles.add.contact.item')}
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="form-group col d-flex required">
            <label htmlFor="type" className="rsee-form-label">
              {locales('fields.contact.type')}
            </label>
            <div className="full-width">
              <select className="form-control" value={type} onChange={onChangeContactType}>
                {ENUMS.CONTACT_TYPES.list.map(x => (
                  <option value={x.value} key={x.value}>
                    {x.title}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-group col d-flex required">
            <label htmlFor="value" className="rsee-form-label">
              {locales('fields.contact.value')}
            </label>
            <div className="full-width">
              <input
                id="value"
                name="value"
                type="text"
                className={`form-control ${valueInputValidateStatus}`}
                placeholder={valuePlaceholder}
                value={value}
                onChange={onChangeValue}
                autoComplete="off"
                maxLength={maxLengthValue}
              />
              <div className="invalid-feedback">{valueInputInvalidMessage}</div>
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-success" onClick={saveContactItem}>
          {props.editMode ? locales('labels.do.edit') : locales('labels.do.add')}
        </button>
        <button type="button" className="btn" onClick={cancel}>
          {locales('labels.cancel')}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default AddOrEditContact;
